// AI Generated Component
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

import { SourceCodeExcludesRoutingModule } from './source-code-excludes-routing.module';
import { SourceCodeExcludesComponent } from './pages/dashboard/source-code-excludes.component';
import { FormSourceCodeExcludeModule } from './form/form-source-code-exclude.module';

// Import shared components and modules
import { SharedModule } from '@client/ng2/shared/shared.module';
import { LayoutModule, MonEventTriggerModule, TableModule } from '@monsido/angular-shared-components';
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { ModalsDirectivesModule } from '@client/app/modules/modals/directives/modals-directives.module';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        SourceCodeExcludesComponent,
    ],
    imports: [
        FormsModule,
        TranslateModule,
        ComponentsModule,
        UpgradePipeModule,
        CommonModule,
        UIRouterModule,
        SourceCodeExcludesRoutingModule,
        SharedModule,
        TableModule,
        NgbModule,
        LayoutModule,
        ModalsDirectivesModule,
        MonEventTriggerModule,
        FormSourceCodeExcludeModule,
    ],
    providers: [],
})
export class SourceCodeExcludesModule {}
